import Vue from 'vue';

var component = {};
if (process.browser) {
  component = require('vue2-dropzone');
}
component.name = 'dropzone';
component.render = function (createElement) {
  var that = this._self;
  return createElement('form', {
    attrs: {
      class: 'dropzone',
      id: that.id || '',
      action: that.url || '',
      dropzoneOptions: that.dropzoneOptions,
      useCustomDropzoneOptions: that.useCustomDropzoneOptions
    }
  }, this.$slots.default);
};
Vue.component('dropzone', component);


//////////////////
// WEBPACK FOOTER
// ./plugins/dropzone.js
// module id = ./plugins/dropzone.js
// module chunks = 152